import clsx from "clsx";
import type { ReactNode } from "react";
import { createPluggable } from "pluggable-react";
import Status from "../Status/Status";
import LoadingSpinner from "../LoadingSpinner/LoadingSpinner";
import styles from "./LoadingStatus.module.scss";

export interface LoadingStatusProps extends React.HTMLAttributes<HTMLDivElement> {
    className?: string;
    children?: ReactNode;
    message?: string;
}

const DefaultLoadingStatus = (props: LoadingStatusProps) => {
    const { className, children, message = "Loading...", ...rest } = props;

    // If children are provided, render them directly (allowing full Status pattern usage)
    // Otherwise, render default layout with spinner and title
    const content = children ? (
        children
    ) : (
        <>
            <Status.Graphic>
                <LoadingSpinner />
            </Status.Graphic>
            <Status.Title>{message}</Status.Title>
        </>
    );

    return (
        <Status className={clsx(styles.loadingStatus, className)} data-deci-loading-status="true" {...rest}>
            {content}
        </Status>
    );
};

const LoadingStatus = createPluggable<LoadingStatusProps>("deci.loadingStatus", DefaultLoadingStatus);

export default Object.assign(LoadingStatus, {
    Graphic: Status.Graphic,
    Title: Status.Title,
    Content: Status.Content,
});
